import { render, staticRenderFns } from "./IconStandardRestrictions.vue?vue&type=template&id=2d22ca1e&"
import script from "./IconStandardRestrictions.vue?vue&type=script&lang=js&"
export * from "./IconStandardRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports